import styled from '@emotion/styled';
import * as infoIcon from '~/assets/icons/icon_info.svg';
import Popup from '~/components/Popup';
import * as React from 'react';
import { colors, fontWeight } from '~/styles/constants';

export type LabelPosition = 'top' | 'bottom' | 'left' | 'right';

export interface LabelProps {
  htmlFor?: string;
  tooltipText?: string;
  tooltipPosition?: LabelPosition;
  disabled?: boolean;
  required?: boolean;
  labelPosition?: LabelPosition;
  multiline?: boolean;
  className?: string;
  children?: React.ReactNode;
  dataAnalytics?: string;
}

const StyledLabel = styled('label')<LabelProps>`
  margin-bottom: ${({ labelPosition }) => (labelPosition !== 'top' ? '0' : '0.25rem')};
  ${({ labelPosition }) =>
    labelPosition === 'left'
      ? `margin-right: .625rem;`
      : labelPosition === 'right'
        ? `margin-left: .625rem;`
        : labelPosition === 'bottom'
          ? `margin-top: .625rem;`
          : undefined}
  color: ${({ disabled }) => (disabled ? colors.form.disabledLabelFontColor : colors.gray700)};
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: ${fontWeight.normal};
  display: inline-flex;
  height: auto;
`;

const Red = styled('span')`
  color: ${colors.dangerRed};
`;

const Icon = styled('img')`
  vertical-align: middle;
`;

const Label = (props: LabelProps) => {
  const label = (
    <StyledLabel
      labelPosition={props.labelPosition || 'top'}
      htmlFor={props.htmlFor}
      disabled={props.disabled}
      className={props.className}
      data-analytics={props.dataAnalytics && `${props.dataAnalytics}Label`}
    >
      {props.children} {props.required ? <Red>*</Red> : null}{' '}
      {props.tooltipText && (
        <Popup
          position={
            `${props.tooltipPosition || 'top'} center` as
              | 'right center'
              | 'left center'
              | 'top center'
              | 'bottom center'
          }
          trigger={
            <div className="ml-1">
              <Icon src={infoIcon} alt="" />
            </div>
          }
          inverted
          size="mini"
          hoverable
        >
          <div className="w-48">{props.tooltipText}</div>
        </Popup>
      )}
    </StyledLabel>
  );

  return <div>{label}</div>;
};

export default Label;
